export default __webpack_public_path__ + "static/media/lv1.8c22f341.png";